import React from 'react';
import {paths} from '../../../common/dictionaries/urls';
import {Link} from 'react-router-dom';
import {Icon} from 'semantic-ui-react';

export const getColumns = () => {
  return [
    {
      'Header': 'DETALLE',
      'width': 65,
      'Filter': () => {
        return null;
      },
      'Cell': ({row}) => {
        return (
          <div style={{'textAlign': 'center'}}>
            <Link to={{
              'pathname': paths.DispatchOrdersEdit.replace(':code', row.original.orderId),
            }}> <Icon name='eye' className='input icon toyota-primary' size='large' />
            </Link>
          </div>
        );
      },
    },
    {
      'Header': 'Nº ORDEN',
      'accessor': 'orderId',
      'width': 100,
    },
    {
      'Header': 'ESTADO',
      'accessor': 'statusDescription',
      'width': 150,
    },
    {
      'Header': 'FECHA CREACIÓN',
      'accessor': 'addDate',
      'width': 150,
      'Cell': ({row}) => {
        return <div style={{'textAlign': 'center'}}>{row.original.addDate}</div>;
      },
    },
    {
      'Header': 'USUARIO',
      'accessor': 'addUser',
      'width': 160,
    },
    {
      'Header': <div style={{'wordBreak': 'break-word', 'whiteSpace': 'break-spaces'}}>FACTURACIÓN ANTICIPADA</div>,
      'accessor': 'anticipatedInvoice',
      'Cell': (row) => {
        return <div style={{'textAlign': 'center'}}>{row.value}</div>;
      },
    },
    {
      'Header': 'TIPO FACTURACIÓN',
      'accessor': 'typeDescription',
      'width': 200,
    },
    {
      'Header': 'FACTURAR A',
      'accessor': 'dealerName',
      'width': 250,
    },
    {
      'Header': 'FECHA MODIFICADO',
      'accessor': 'updateDate',
      'width': 150,
      'Cell': ({row}) => {
        return <div style={{'textAlign': 'center'}}>{row.original.updateDate}</div>;
      },
    },
    {
      'Header': 'MODIFICADO POR',
      'accessor': 'updateUser',
      'width': 160,
    },
  ];
};
